.sbsDocs {
  width: 40%;
}
